module.exports = __webpack_public_path__ + "static/media/Rove - Itinerary - 22 March 2023.412e5554.mp4";